define(["exports", "react", "styled-components", "polished"], function (_exports, _react, _styledComponents, _polished) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Avatar = void 0;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);

  var stringToColour = function stringToColour(str) {
    var hash = 0;
    var colour = '#';

    for (var indx = 0; indx < (str == null ? void 0 : str.length); indx++) {
      hash = str.charCodeAt(indx) + ((hash << 5) - hash);
    }

    for (var i = 0; i < 3; i++) {
      var value = hash >> i * 8 & 0xff;
      colour += ('00' + value.toString(16)).substr(-2);
    }

    return colour;
  };

  var AvatarStyled = _styledComponents.default.div.attrs(function (_ref) {
    var background = _ref.background,
        color = _ref.color;
    return {
      style: {
        backgroundColor: background,
        color: color
      }
    };
  }).withConfig({
    displayName: "Avatar__AvatarStyled",
    componentId: "sc-pn5ixo-0"
  })(["align-items:center;box-shadow:0 0 0 2px ", ";border-radius:50%;display:flex;font-weight:", ";justify-content:center;overflow:hidden;", " ", " ", " ", " img{display:block;height:100%;object-fit:cover;width:100%;}"], function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.white;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.font.semibold;
  }, function (_ref4) {
    var size = _ref4.size;
    return size === 'lg' && (0, _styledComponents.css)(["height:64px;min-width:64px;width:64px;font-size:3.2em;"]);
  }, function (_ref5) {
    var size = _ref5.size;
    return size === 'md' && (0, _styledComponents.css)(["height:40px;min-width:40px;width:40px;font-size:1.6em;"]);
  }, function (_ref6) {
    var size = _ref6.size;
    return size === 'sm' && (0, _styledComponents.css)(["height:32px;min-width:32px;width:32px;font-size:1.4em;"]);
  }, function (_ref7) {
    var size = _ref7.size;
    return size === 'xs' && (0, _styledComponents.css)(["height:24px;min-width:24px;width:24px;font-size:1.1em;"]);
  });

  var createInitials = function createInitials(name) {
    var nameArray = name == null ? void 0 : name.trim().split(' ');
    var totalName = nameArray == null ? void 0 : nameArray.length;

    if (totalName > 1) {
      return "" + (nameArray == null ? void 0 : nameArray[0].charAt(0).toUpperCase()) + (nameArray == null ? void 0 : nameArray[totalName - 1].charAt(0).toUpperCase());
    } else {
      return "" + (nameArray == null ? void 0 : nameArray[0].charAt(0).toUpperCase()) + ((nameArray == null ? void 0 : nameArray[0].charAt(1)) === '.' ? nameArray == null ? void 0 : nameArray[0].charAt(2).toUpperCase() : nameArray == null ? void 0 : nameArray[0].charAt(1).toUpperCase());
    }
  };

  var Avatar = function Avatar(_ref8) {
    var kind = _ref8.kind,
        name = _ref8.name,
        src = _ref8.src,
        size = _ref8.size;
    return /*#__PURE__*/_react.default.createElement(AvatarStyled, {
      "data-testid": "avatar",
      size: size,
      name: name,
      background: (0, _polished.lighten)(0.2, stringToColour(name)),
      color: (0, _polished.readableColor)((0, _polished.lighten)(0.18, stringToColour(name)), '#fff', '#fff')
    }, kind === 'image' && src ? /*#__PURE__*/_react.default.createElement("img", {
      src: src,
      "data-testid": "img",
      alt: name,
      title: name
    }) : /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": "text",
      title: name
    }, createInitials(name)));
  };

  _exports.Avatar = Avatar;
  Avatar.defaultProps = {
    src: '',
    size: 'md'
  };
});